import { get } from './ObjectHelper';
import { Action } from '../ApiModel';
import { hasValue } from './ArrayHelper';

export function needsInteraction(action: Action) {
    if (action.status !== 'in-progress') return false;
    const interactionRequired = get(action, 'user_interaction_required');
    if (!interactionRequired) return false;
    return true;
}

// Waiting on the user (a decision, or an unpaid invoice), so its dock card carries a control.
export function requiresUserAttention(action: Action) {
    return needsInteraction(action) || hasValue(action.blocking_invoice_id);
}

export function hasTerminated(action: Action) {
    return action.status === 'completed' || action.status === 'errored';
}

export function shouldShowConsole(action: Action) {
    // must be a server action
    const serverId = getServerIdFromActionResource(action);
    if (!hasValue(serverId)) return false;

    // only show console for create actions during OS configuration;
    // for other actions the user can minimize the modal to see the console on the dashboard
    if (action.type !== 'create') return false;

    // no console needed once the action has finished
    if (hasTerminated(action)) return false;

    // must be configuring or have configured operating system
    const ConsoleActionText = 'Configuring operating system';
    return (
        action.progress.current_step === ConsoleActionText ||
        action.progress.completed_steps.includes(ConsoleActionText)
    );
}

export function getServerIdFromActionResource(action: Action): number | undefined {
    if (action.resource_type === 'server') return action.resource_id ?? undefined;
}
